import ClientService from '@/services/client.service'

const state = {
    isLoading: false,
    client: undefined,
}

const getters = {
    //
}

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = !!isLoading
    },

    setClient(state, client) {
        state.client = client
    },
}

const actions = {
    async fetch({ commit }) {
        commit('setLoading', true)

        let response

        try {
            response = await ClientService.getClient()

            commit('setClient', response.client)
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
